export const deskBreakpoint = '@media only screen and (min-width: 1025px)';
export const tabBreakpoint = '@media only screen and (max-width: 1024px)';
export const mobileBreakpoint = '@media only screen and (max-width: 640px)';

export const primaryColor = '#146EF5';
export const primaryColor100 = '#e7f0fe';
export const primaryColor200 = '#b6d2fc';
export const primaryColor300 = '#85b4fa';
export const primaryColor400 = '#5495f8';
export const primaryColor500 = '#2377f6';
export const primaryColor600 = '#095edc';
export const primaryColor700 = '#0749ab';
export const primaryColor800 = '#05347a';
export const primaryColor900 = '#031f49';
export const primaryColor1000 = '#010a18';
export const secondaryColor = '#FF7A00';
export const titleColor = '#070127';
export const contentColor = '#485781';

export const gradient = 'linear-gradient(135deg, #0040E3, #18D4FD)';
